import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { useContext, useMemo, createElement } from 'react';
import cls from 'classnames';
import { ThemeProvider, ThemeContext } from '@hzero-front-ui/core/lib/utils/ThemeContext';
export var NO_UED_WRAPPER_CLASS_NAME = 'hzero-no-ued-wrapper';
export var NO_UED_SCOPE_SELECTOR = ".page-container > div:not(.".concat(NO_UED_WRAPPER_CLASS_NAME, ")");
var NoUedWrapper = function NoUedWrapper(props) {
  var _props$noUed = props.noUed,
    noUed = _props$noUed === void 0 ? true : _props$noUed,
    className = props.className,
    _props$htmlTag = props.htmlTag,
    htmlTag = _props$htmlTag === void 0 ? 'div' : _props$htmlTag,
    children = props.children;
  var contextValue = useContext(ThemeContext);
  var newContextValue = useMemo(function () {
    return _objectSpread({}, contextValue, {
      schema: 'theme2'
    });
  }, [contextValue]);
  return noUed ? /*#__PURE__*/React.createElement(ThemeProvider, {
    value: newContextValue
  }, createElement(htmlTag, {
    className: cls(NO_UED_WRAPPER_CLASS_NAME, className)
  }, children)) : createElement(htmlTag, {
    className: className
  }, children);
};
export default NoUedWrapper;